import { useEffect, useState } from 'react';
import { Card, EmptyState, PageHeader } from '@/components/ui';
import { toast } from '@/components/ui/Toast';
import { agentApi } from '@/shared/api/agentApi';

interface Shift {
  id: number;
  date: string;
  start: string;
  end: string;
  status: string;
}

export function Shifts() {
  const [items, setItems] = useState<Shift[]>([]);
  const [loading, setLoading] = useState(true);

  function load() {
    void agentApi.shifts().then((d) => {
      setItems(d as Shift[]);
      setLoading(false);
    });
  }

  useEffect(() => { load(); }, []);

  async function requestSwap(id: number) {
    try {
      await agentApi.requestShiftSwap(id);
      toast('בקשת החלפה נשלחה', 'ok');
      load();
    } catch {
      toast('שגיאה בשליחת הבקשה', 'danger');
    }
  }

  if (loading) return <Card>טוען…</Card>;
  if (!items.length) return <EmptyState icon="calendar" title="אין משמרות מוגדרות" />;

  return (
    <div className="stack" style={{ padding: 'var(--gap)' }}>
      <PageHeader title="משמרות השבוע" />
      <Card padded={false}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ background: 'var(--surface-2)' }}>
            <tr>
              <th style={{ textAlign: 'start', padding: 12 }}>תאריך</th>
              <th style={{ textAlign: 'start', padding: 12 }}>התחלה</th>
              <th style={{ textAlign: 'start', padding: 12 }}>סיום</th>
              <th style={{ textAlign: 'start', padding: 12 }}>סטטוס</th>
              <th style={{ textAlign: 'start', padding: 12 }}></th>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id} style={{ borderBottom: '1px solid var(--line)' }}>
                <td style={{ padding: 12 }}>{s.date}</td>
                <td style={{ padding: 12, fontFamily: 'var(--font-mono)' }} dir="ltr">{s.start}</td>
                <td style={{ padding: 12, fontFamily: 'var(--font-mono)' }} dir="ltr">{s.end}</td>
                <td style={{ padding: 12 }}>{s.status}</td>
                <td style={{ padding: 12, textAlign: 'end' }}>
                  {s.status !== 'swap_requested' && (
                    <button type="button" className="btn" onClick={() => requestSwap(s.id)}>
                      בקש החלפה
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
